import { render, staticRenderFns } from "./BreadcrumbMenu.vue?vue&type=template&id=faf86478&scoped=true&"
import script from "./BreadcrumbMenu.vue?vue&type=script&lang=js&"
export * from "./BreadcrumbMenu.vue?vue&type=script&lang=js&"
import style0 from "./BreadcrumbMenu.vue?vue&type=style&index=0&id=faf86478&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faf86478",
  null
  
)

export default component.exports